import { mdiShape } from '@mdi/js';
import PropTypes from 'prop-types';
import React from 'react';

import { graff } from '../graff';

// The UpStick logo: a small pink « sticker » tilted on the wall, then « Up » ink + « Stick » pink
// (docs/design/bo-maquette-A-graff-soigne.html, .brand). `compact`: the sticker alone (closed menu).
const styles = {
  root: { display: 'flex', alignItems: 'center', gap: 10 },
  mark: {
    width: 32,
    height: 32,
    flexShrink: 0,
    borderRadius: 10,
    backgroundColor: graff.color.pink,
    color: '#fff',
    display: 'grid',
    placeItems: 'center',
    transform: 'rotate(-6deg)',
    boxShadow: '0 0 0 3px #fff, 0 6px 14px -4px rgba(224,20,110,.55)',
  },
  name: {
    fontFamily: graff.font.display,
    fontSize: 26,
    letterSpacing: '.5px',
    lineHeight: 1,
    color: graff.color.ink,
    whiteSpace: 'nowrap',
  },
};

const UpStickLogo = ({ compact = false }) => (
  <div style={styles.root} aria-label="UpStick">
    <div style={styles.mark}>
      <svg viewBox="0 0 24 24" width={18} height={18} aria-hidden="true">
        <path d={mdiShape} fill="currentColor" />
      </svg>
    </div>
    {!compact && (
      <div style={styles.name}>
        Up<span style={{ color: graff.color.pink }}>Stick</span>
      </div>
    )}
  </div>
);

UpStickLogo.propTypes = {
  compact: PropTypes.bool,
};

export default UpStickLogo;
